$shm_dashboard_admin_user_dashboards_auto_update $mol_pick
	Follower $shm_dashboard_admin_user_dashboards_follower
		offset <= bubble_offset
		align <= bubble_align
		Anchor <= Anchor
		Sub <= Bubble
